import type { JobNoteWithRelations } from '@maker-toolchest/shared';
import { formatDistanceToNow } from 'date-fns';
import { Pin, Trash2 } from 'lucide-react';

interface NotesListProps {
  notes: JobNoteWithRelations[];
  onDelete?: (noteId: string) => void;
  loading?: boolean;
}

export function NotesList({ notes, onDelete, loading }: NotesListProps) {
  if (notes.length === 0) {
    return (
      <div className="rounded border border-border bg-background-subtle p-8 text-center">
        <p className="text-foreground-muted">No notes yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {notes.map((note) => (
        <div
          key={note.id}
          className="rounded border border-border bg-background-subtle p-3"
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1">
              <p className="text-sm text-foreground whitespace-pre-wrap">{note.content}</p>
              <div className="mt-2 flex items-center gap-2 text-xs text-foreground-muted">
                <span>{note.user.name}</span>
                <span>·</span>
                <span>{formatDistanceToNow(new Date(note.createdAt), { addSuffix: true })}</span>
              </div>
            </div>
            <div className="flex items-center gap-1">
              {note.isPinned && (
                <Pin className="h-4 w-4 text-primary fill-primary" />
              )}
              {onDelete && (
                <button
                  onClick={() => onDelete(note.id)}
                  disabled={loading}
                  className="text-foreground-muted hover:text-error disabled:opacity-50"
                  aria-label="Delete note"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
